import { isDocumentEmpty } from '@gitbook/doc-core';
import type { EditorContainer } from '@gitbook/slate-react';

/**
 * Focuses an editor.
 */
export function focusEditor(
    editor: EditorContainer | undefined | null,
    options: { collapseToStart: boolean } = { collapseToStart: false }
) {
    if (!editor) {
        return;
    }

    editor.change((change) => {
        if (options.collapseToStart && !isDocumentEmpty(change.value.document)) {
            change.collapseToStartOf(editor.value.document);
        }
        change.focus();
    });
}
